import React, { Fragment, Component } from "react";
import { Button, Confirm, withDataProvider } from "react-admin";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { FormGroup, Checkbox, FormControlLabel } from "@material-ui/core";
import { withStyles, createStyles } from "@material-ui/core/styles";
import ActionDelete from "@material-ui/icons/Delete";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { hasPatientToken } from "../../redux/patients/selectors";
import { crudDeleteManyWithChecked } from "./actions";

const styles = (theme) =>
  createStyles({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: fade(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  });

class DeleteManyConfirmButton_ extends Component {
  state = { isOpen: false, showWidget: false, checked: false };

  handleClick = () => {
    this.setState({ isOpen: true, showWidget: true });
  };

  handleDialogClose = () => {
    this.setState({ isOpen: false });
  };
  handleChangeCheckbox = (e) => {
    this.setState({ checked: e.target.checked });
  };

  handleConfirm = () => {
    const {
      selectedIds,
      dispatchCrudDeleteMany,
      basePath,
      resource,
    } = this.props;
    this.setState({ isOpen: false, showWidget: false });
    dispatchCrudDeleteMany(
      resource,
      selectedIds,
      this.state.checked,
      basePath,
      true
    );
  };

  getConfirmContent = () => {
    const { selectedIds, hasPatientToken } = this.props;
    if (selectedIds && selectedIds.length > 1) {
      return `Are you sure want to remove ${selectedIds.length} patients ?`;
    }
    if (hasPatientToken === false) {
      return "Are you sure want to remove this patient ?";
    }

    return (
      <FormGroup>
        <FormControlLabel
          control={<Checkbox onChange={this.handleChangeCheckbox} />}
          label="Remove the patient from PowerDot Consumer database too"
        />
      </FormGroup>
    );
  };

  getConfirm = () => {
    if (this.state.showWidget) {
      return (
        <Confirm
          isOpen={this.state.isOpen}
          title="Remove Patient"
          content={this.getConfirmContent()}
          onConfirm={this.handleConfirm}
          onClose={this.handleDialogClose}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <Fragment>
        <Button
          label="Delete"
          onClick={this.handleClick}
          icon={<ActionDelete />}
          className={this.props.classes.deleteButton}
        />
        {this.getConfirm()}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  hasPatientToken: hasPatientToken(state, ownProps),
});

const DeleteManyConfirmButton = compose(
  connect(mapStateToProps, {
    dispatchCrudDeleteMany: crudDeleteManyWithChecked,
  }),
  withStyles(styles)
)(DeleteManyConfirmButton_);
export default withDataProvider(DeleteManyConfirmButton);
